<template>
    <div>
        <div
            class="ah-el-table-sticky-header wrapper"
            ref="wrapper"
            :class="[{isShown: isShown}, size]"
            :style="{
                top: `${fixedY}px`,
                left: `${refWrapperRect.left}px`,
                width: `${refWrapperRect.width}px`,
            }"
        >
            <div class="scroller" ref="scroller">
                <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    :style="{ width: `${refTableWidth}px` }"
                >
                    <thead>
                        <tr>
                            <th
                                v-for="(th, index) in refThList"
                                :key="index"
                                :class="th.className"
                                :style="{width: `${getThWidth(th)}px`, height: `${getThHeight(th)}px`}"
                            >
                                <div class="cell">{{ th.textContent }}</div>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="left-fixed-header">
                <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    :style="{ width: `${refTableWidth}px` }"
                >
                    <thead>
                        <tr>
                            <th
                                v-for="(th, index) in refLeftFixedThList"
                                :key="index"
                                :class="th.className"
                                :style="{width: `${getThWidth(th)}px`, height: `${getThHeight(th)}px`}"
                            >
                                <div class="cell" >{{ th.textContent }}</div>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="right-fixed-header">
                <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    :style="{ width: `${refTableWidth}px` }"
                >
                    <thead>
                        <tr>
                            <th
                                v-for="(th, index) in refRightFixedThList"
                                :key="index"
                                :class="th.className"
                                :style="{width: `${getThWidth(th)}px`, height: `${getThHeight(th)}px`}"
                            >
                                <div class="cell" >{{ th.textContent }}</div>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        fixedY: {
            type: Number,
            default: 65,
        },
    },
    data() {
        return {
            isShown: false,
            size: 'normal',
            refWrapper: null,
            refTable: null,
            refTableBodyWrapper: null,
            refThList: [],
            refLeftFixedThList: [],
            refRightFixedThList: [],
            refTableWidth: 0,
            refWrapperRect: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
        };
    },
    computed: {

    },
    mounted() {
        // 尋找 slots 裡的第一個元件
        if (this.$slots.default.length === 0) {
            return;
        }

        // 取的 el-table 的 size
        const elTable = this.$slots.default[0].componentInstance.$el;
        if (elTable.classList.contains('el-table--small')) {
            this.size = 'small';
        }

        // 紀錄 el-table 元件的 wrapper, table_header, 和 th
        this.refWrapper = elTable.querySelector('.el-table__header-wrapper');
        this.refTable = elTable.querySelector('.el-table__header');
        this.refTableBodyWrapper = elTable.querySelector('.el-table__body-wrapper');

        // 固定表頭
        setTimeout(() => {
            const leftFixedTable = elTable.querySelector('.el-table__fixed');
            if (leftFixedTable) {
                this.refLeftFixedThList = leftFixedTable.querySelectorAll('.el-table__fixed-header-wrapper th');
                console.log('this.refLeftFixedThList', this.refLeftFixedThList);
            }

            const rightFixedTable = elTable.querySelector('.el-table__fixed-right');
            if (rightFixedTable) {
                this.refRightFixedThList = rightFixedTable.querySelectorAll('.el-table__fixed-header-wrapper th');
                console.log('this.refRightFixedThList', this.refRightFixedThList);
            }
        }, 150);

        const theads = elTable.getElementsByTagName('thead');
        this.refThList = theads[0].children[0].children;

        // 註冊事件
        setTimeout(() => {
            this.updateSizes();
            window.addEventListener('resize', this.onWindowResize);
            window.addEventListener('scroll', this.onScroll);
            this.refTableBodyWrapper.addEventListener('scroll', this.onTableBodyScroll);
        }, 100);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('scroll', this.onScroll);
        this.refTableBodyWrapper.removeEventListener('scroll', this.onTableBodyScroll);
    },
    methods: {
        getThWidth(el) {
            return el.getBoundingClientRect().width;
        },
        getThHeight(el) {
            return el.getBoundingClientRect().height;
        },
        onWindowResize() {
            this.updateSizes();
        },
        updateSizes() {
            // 紀錄 wrapper 的尺寸＆位置
            if (this.refWrapper) {
                const rect = this.refWrapper.getBoundingClientRect();
                this.refWrapperRect = {
                    x: window.scrollX + rect.x,
                    y: window.scrollY + rect.y,
                    width: rect.width,
                    height: rect.height,
                };
            }

            // 紀錄表格總寬度
            if (this.refTable) {
                this.refTableWidth = this.refTable.getBoundingClientRect().width;
            }
        },
        onScroll() {
            // 要觸發顯示的高度
            const triggerY = this.refWrapperRect.y - this.refWrapperRect.height - 5;
            // console.log(`triggerY: ${triggerY}, y: ${window.scrollY}`);

            // 依高度判斷是否顯示
            if (window.scrollY >= triggerY) {
                if (!this.isShown) {
                    this.updateSizes();
                    this.isShown = true;
                }
            } else {
                if (this.isShown) {
                    this.isShown = false;
                }
            }
        },
        // 橫向滾動
        onTableBodyScroll(event) {
            this.$refs.scroller.scroll(event.target.scrollLeft, 0);
        },
    },
};
</script>
<style scoped lang="scss">
.ah-el-table-sticky-header-outter {
    position: relative;

    .fixed-thead {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        overflow: hidden;
    }
}
.ah-el-table-sticky-header {
    position: fixed;
    width: 100%;
    background-color: #fff;
    font-size: 14px;
    color: #000;
    border-bottom: 1px solid #ddd;
    overflow: hidden;
    z-index: 10;
    display: none;
    box-shadow: 0 4px 5px -4px rgba(0, 0, 0, 0.2);

    @media print {
        display: none;
    }

    &::-webkit-scrollbar {
    display: none;
    }

    &.small {
        padding: 8px 0;
        font-size: 12px;
    }

    &.isShown {
        display: block;

        @media print {
            display: none;
        }
    }

    .scroller {
        overflow-x: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .left-fixed-header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
    }
    .right-fixed-header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;

        > table {
            position: absolute;
            right: 0;
        }
    }

    table {
        width: 100%;
    }
    th {
        text-align: left;
        font-weight: normal;
        &.is-right {
            text-align: right;
        }
        &.gutter {
            display: none;
        }
        .cell {
            padding: 0 10px;
        }
        background-color: #fff;
    }
    th.is-hidden {
        visibility: hidden;
    }
}
</style>
